module.exports = __webpack_public_path__ + "static/media/location.f6fbdc7e.svg";